import _classCallCheck from "/tmp/build_f973a96b/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/build_f973a96b/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/tmp/build_f973a96b/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/tmp/build_f973a96b/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/tmp/build_f973a96b/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { PureComponent } from 'react';
import { objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';

// see https://github.com/oliviertassinari/react-event-listener/
var EventListener = /*#__PURE__*/function (_PureComponent) {
  _inherits(EventListener, _PureComponent);
  function EventListener() {
    _classCallCheck(this, EventListener);
    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
  }
  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.attachListener();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var detachProps = _objectWithoutProperties(_ref, ["passive"]);
      this.detachListener(detachProps);
      this.attachListener();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.detachListener();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }, {
    key: "attachListener",
    value: function attachListener() {
      var _this$props = this.props,
        event = _this$props.event,
        handler = _this$props.handler,
        capture = _this$props.capture,
        passive = _this$props.passive;
      window.addEventListener(event, handler, {
        capture: capture,
        passive: passive
      });
    }
  }, {
    key: "detachListener",
    value: function detachListener(prevProps) {
      var _ref2 = prevProps || this.props,
        event = _ref2.event,
        handler = _ref2.handler,
        capture = _ref2.capture;
      window.removeEventListener(event, handler, capture);
    }
  }]);
  return EventListener;
}(PureComponent);
export { EventListener };